import React from "react";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    label: string,
    stereotype?: boolean
}

const TaskGame3: React.FunctionComponent<Props> = () => {

    const data : Item[] = [
        {
            label: 'Muzułmanie mają dużo dzieci, więc istnieje niebezpieczeństwo, że za kilka lat zdominują Europę.',
            stereotype: true
        },
        {
            label: 'Mózgi kobiet i mężczyzn różnią się, dlatego przedstawiciele różnych płci nadają się do wykonywania odmiennych zadań.',
            stereotype: true
        },
        {
            label: 'Każdy ma stereotypy i uprzedzenia.'
        },
        {
            label: 'Kobiety mają specjalny zmysł, który ułatwia im prowadzenie domu, robienie porządków i gotowanie.',
            stereotype: true
        },
        {
            label: 'Mężczyźni są stanowczy i zdecydowani, dlatego to oni powinni sprawować władzę.',
            stereotype: true
        },
        {
            label: 'Wszyscy Polacy są złodziejami lub cwaniakami.',
            stereotype: true
        },
        {
            label: 'Niewidomi mają idealny słuch.',
            stereotype: true
        },
        {
            label: 'Kobiety w swojej karierze zawodowej rozbijają się o szklany sufit.'
        }
    ]

    return (
        <ul className="task-game-3">
            {
                data.map((i, index) => {
                    return (
                        <li key={index}>
                            <p>{i.label}</p>
                            <div className="buttons">
                                <label className={`${i.stereotype ? 'correct' : 'wrong'}`}>
                                    <input type="radio" name={`r-${index}`} />
                                    <span>STEREOTYP</span>
                                </label>
                                <label className={`${!i.stereotype ? 'correct' : 'wrong'}`}>
                                    <input type="radio" name={`r-${index}`} />
                                    <span>FAKT</span>
                                </label>
                            </div>
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default TaskGame3;
